<template>
    <div
        class="notification fixed w-full xl:w-[75rem] z-20 top-[103px] md:top-[111px] xl:pr-4 2xl:w-[99rem] flex flex-col gap-2"
    >
        <template v-for="notification in notifications" :key="`${notification.id}-notification.type`">
            <component
                :is="notificationsComponent(notification.type)"
                :id="notification.id"
                :content="notification"
                @notification:close="onClose"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import type { Notification } from './notification'
    import type { NotificationType } from '@/layers/nuxt-bbk-notification-layer/types/notification'

    const { $bus } = useNuxtApp()

    const notifications = ref<Notification[]>([])
    const id = ref(0)

    function notificationsComponent(type: NotificationType) {
        switch (type) {
            case 'addToCart':
                return resolveComponent('LazyShcUiNotificationCart')
            case 'addToCartProduct':
                return resolveComponent('LazyShcUiNotificationCartProduct')
            case 'success':
                return resolveComponent('LazyShcUiNotificationSuccess')
            case 'error':
                return resolveComponent('LazyShcUiNotificationError')
        }
    }

    $bus.$on('notification', (notification) => {
        notifications.value.push({ ...notification, id: id.value++ })
    })

    function onClose(event: { index: number }) {
        notifications.value = notifications.value.filter((item) => {
            return item.id !== event.index
        })
    }
</script>

<style lang="scss" scoped>
    .usp-standard {
        .notification {
            @apply md:top-[164px];
        }
    }

    .usp-promotion {
        .notification {
            @apply md:top-[180px];
        }
    }

    .header-is-sticky {
        .notification {
            @apply md:top-[45px];
        }
    }
</style>
